export default __webpack_public_path__ + "static/media/thumbnail.5a4bf26c.webp";